<section id="foto-polaroid">
    <div class="container-page">
        <div class="divisor">
            <div class="texto-polaroid">
                <div [innerHTML]="config.title"></div>
                <p [innerHTML]="config.paragraph"></p>
                <a href="{{config.buttonUrl}}" class="comienza azul">{{config.buttonText}}</a>
            </div>
            <div class="foto-polaroid">
                <img src="{{config.image}}" alt="" class="toronjita">
                <div class="fotos-card">
                    <img src="{{config.cardImage}}" alt="">
                    <div class="content-foto">
                        <div class="h4">{{config.cardParagraph}}</div>
                        <div class="centrar-boton">
                            <a href="{{config.cardButtonUrl}}" class="comienza azul">{{config.cardButtonText}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>